import { cartLinesStyles as styles } from "@hardware/Overrides/Widgets/Cart/CartLines";
import { colorStrings } from "@hardware/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.header!.quoteRequiredNote = {
    css: css`
        display: flex;
        align-items: center;
        border: 2px solid ${getColor(colorStrings.warningMain)};
        background-color: #fff6c5;
        margin-block: 10px;
        padding: 15px 10px;
        font-size: 15px;
        font-weight: bold;
    `,
};
